var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.currentStep.hidden
        ? _c(
            "v-stepper",
            {
              attrs: { "alt-labels": "" },
              model: {
                value: _vm.currentStep_Id,
                callback: function($$v) {
                  _vm.currentStep_Id = $$v
                },
                expression: "currentStep_Id"
              }
            },
            [
              _c(
                "v-stepper-header",
                { staticClass: "elevation-15" },
                [
                  _vm._l(_vm.activeSteps, function(step, model) {
                    return [
                      _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            step: step._id || step.id,
                            complete: step.success,
                            rules: [
                              function() {
                                return !step.error
                              }
                            ]
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(step.name) +
                              "\n                    "
                          ),
                          _c("small", [_vm._v(_vm._s(step.error))])
                        ]
                      ),
                      _vm._v(" "),
                      model < _vm.activeSteps.length - 1
                        ? _c("v-divider")
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { position: "relative" } },
        [
          _c(
            "v-carousel",
            {
              staticClass: "show-overflow",
              attrs: {
                "hide-delimiters": "",
                "show-arrows": false,
                height: "auto",
                touchless: true
              },
              model: {
                value: _vm.currentStepIndex,
                callback: function($$v) {
                  _vm.currentStepIndex = $$v
                },
                expression: "currentStepIndex"
              }
            },
            _vm._l(_vm.steps, function(step) {
              return _c(
                "v-carousel-item",
                { key: "step_" + step.id },
                [_c(step.component, { tag: "component" })],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }